// extracted by mini-css-extract-plugin
export default {"content":"pagination-box_content__1CsCN","btn_box":"pagination-box_btn_box__EgxZv","btn":"pagination-box_btn__T9ku2","num_btn":"pagination-box_num_btn__xqcVb"};